import { render, staticRenderFns } from "./callout.vue?vue&type=template&id=136c3175&"
import script from "./callout.vue?vue&type=script&lang=js&"
export * from "./callout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "callout.vue"
export default component.exports